import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Badge } from 'app/scripts/components/common/badge';

class Switch extends Component {
  static defaultProps = {
    controlsProps: {}
  };

  constructor(props) {
    super(props);
    this.toggleFollow = this.toggleFollow.bind(this);
  }

  toggleFollow() {
    if (!this.props.disabled) {
      var value = !this.props.value;
      this.props.onChange(value);
    }
  }

  render() {
    var {
      value,
      description,
      title,
      noContent,
      gapTopSize,
      withLearnMore,
      containerClassName,
      controlsProps,
      isNew,
      disabled
    } = this.props;

    var className = classnames('enabled', {
      disabled: !value
    });

    return (
      <div
        className={classnames(containerClassName, 'field', className, {
          ['--gap-top-size-' + gapTopSize]: gapTopSize || null
        })}
        style={noContent ? { marginTop: 0 } : {}}
      >
        <div className="field-title" style={{ marginBottom: 0 }}>
          <div className="header">
            {isNew && <Badge label="New" type="outlined" color="#2778CE" />}
            {noContent ? '' : title}
          </div>
          {withLearnMore}
        </div>
        {description ? (
          <div className="field-description">{noContent ? '' : description}</div>
        ) : null}
        <div {...controlsProps} className={classnames('switch-input', controlsProps.className)}>
          <label className="green-switch">
            <input
              type="checkbox"
              className="switch-input"
              onChange={this.toggleFollow}
              checked={value}
              disabled={disabled}
            />
            <span className="switch-label" />
            <span className="switch-handle" />
          </label>
          <span onClick={this.toggleFollow} className={className}>
            {value ? 'Enabled' : 'Disabled'}{' '}
          </span>
        </div>
      </div>
    );
  }
}

Switch.propTypes = {
  value: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  noContent: PropTypes.bool,
  withLearnMore: PropTypes.object,
  containerClassName: PropTypes.string,
  isNew: PropTypes.bool,
  disabled: PropTypes.bool
};

Switch.displayName = 'Switch';

export default Switch;
